import { __decorate } from "tslib";
import { action, computed, observable } from 'mobx';
import { columnWidth } from './Column';
import ColumnGroups from './ColumnGroups';
import { getColumnKey, getColumnLock } from './utils';
export default class ColumnGroup {
    constructor(column, parent, store) {
        this.store = store;
        this.column = column;
        this.key = getColumnKey(column);
        this.parent = parent;
        const { children } = column;
        const { aggregation } = parent;
        if (children && children.length > 0) {
            if (!column.aggregation || !aggregation) {
                this.children = new ColumnGroups(children, store, this);
            }
            else {
                this.childrenInAggregation = new ColumnGroups(children, store, this);
            }
        }
    }
    get lock() {
        return getColumnLock(this.column.lock);
    }
    get rowSpan() {
        return this.parent.deep - this.deep + 1;
    }
    get colSpan() {
        const { children } = this;
        return children ? children.wide : 1;
    }
    get deep() {
        const { children } = this;
        return children ? children.deep + 1 : this.hidden ? 0 : 1;
    }
    get hidden() {
        const { children } = this;
        return children ? children.hidden : !!this.column.hidden;
    }
    get lastLeaf() {
        const { leafs } = this;
        const { length } = leafs;
        return length ? leafs[length - 1] : undefined;
    }
    get width() {
        const { children } = this;
        return children ? children.width : columnWidth(this.column, this.store);
    }
    get left() {
        const { prev } = this;
        if (prev) {
            return prev.left + prev.width;
        }
        const { parent } = this;
        if (parent) {
            return parent.left;
        }
        return 0;
    }
    get right() {
        const { next } = this;
        if (next) {
            return next.right + next.width;
        }
        const { parent } = this;
        if (parent) {
            return parent.right;
        }
        return 0;
    }
    get allLeafs() {
        const { children } = this;
        if (children) {
            return children.leafs;
        }
        return [this];
    }
    get leafs() {
        const { hidden } = this;
        if (!hidden) {
            return this.allLeafs;
        }
        return [];
    }
    get headerGroup() {
        const { __group } = this.column;
        if (__group) {
            return __group;
        }
        return this.parent.rowGroup;
    }
    setInView(inView) {
        this.inView = inView;
    }
}
__decorate([
    observable
], ColumnGroup.prototype, "inView", void 0);
__decorate([
    computed
], ColumnGroup.prototype, "left", null);
__decorate([
    computed
], ColumnGroup.prototype, "right", null);
__decorate([
    computed
], ColumnGroup.prototype, "allLeafs", null);
__decorate([
    computed
], ColumnGroup.prototype, "leafs", null);
__decorate([
    action
], ColumnGroup.prototype, "setInView", null);
